import {gql} from '@apollo/client';

import {QueryResultType, useBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';

import {RequestTaskSchemaGraphQL} from '../../../graphql-fragments/requests/schemas/__generated/RequestTaskSchemaGraphQL';
import {
  GetRequestTaskSchemaQuery,
  GetRequestTaskSchemaQueryVariables,
} from './__generated/GetRequestTaskSchemaQuery';

export const GET_REQUEST_TASK_SCHEMA_QUERY = gql`
  query GetRequestTaskSchemaQuery($id: StrictString!) @skipAudit @engComponent(name: REQUESTS) {
    requestTaskSchema(id: $id) {
      ...RequestTaskSchemaGraphQL
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('RequestTaskSchema').fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export default function useRequestTaskSchemaQuery(id: string): RequestTaskSchemaGraphQL | null {
  const result = useBenchlingQuery<GetRequestTaskSchemaQuery, GetRequestTaskSchemaQueryVariables>(
    GET_REQUEST_TASK_SCHEMA_QUERY,
    {variables: {id}}
  );

  if (result.type !== QueryResultType.SUCCESS || isInaccessible(result.data.requestTaskSchema)) {
    return null;
  } else {
    return result.data.requestTaskSchema;
  }
}
